export default {"src":"https://cdn.jetlend.ru/_next/static/media/department-risks.f9eae084.svg","height":20,"width":20,"blurWidth":0,"blurHeight":0};